import { Link } from 'react-router';

const COLS: ReadonlyArray<{
  title: string;
  links: ReadonlyArray<{ label: string; to: string }>;
}> = [
  {
    title: 'Produit',
    links: [
      { label: 'Démo', to: '/demo' },
      { label: 'Fonctionnalités', to: '/fonctionnalites' },
      { label: 'Velko Bar', to: '/velko-bar' },
      { label: 'Troc & reprise', to: '/troc' },
      { label: 'Gestion des retours', to: '/gestion-retours' },
      { label: 'Partenaires & dépôt-vente', to: '/partenaires' },
      { label: 'Velko vs cahier de caisse', to: '/velko-vs-cahier-de-caisse' },
      { label: 'Tarifs', to: '/tarifs' },
      { label: 'Télécharger', to: '/telechargement' },
      { label: "Guide d'installation", to: '/guide-installation' },
      { label: 'Blog', to: '/blog' },
    ],
  },
  {
    title: 'Entreprise',
    links: [
      { label: 'À propos', to: '/a-propos' },
      { label: 'Contact', to: '/contact' },
      { label: 'Support', to: '/contact' },
    ],
  },
  {
    title: 'Légal',
    links: [
      { label: 'Mentions légales', to: '/mentions-legales' },
      { label: 'Confidentialité', to: '/politique-confidentialite' },
      { label: 'CGV', to: '/conditions-utilisation' },
      { label: 'Suppression des données', to: '/suppression-donnees' },
    ],
  },
];

export function FooterMarketingV2() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-charcoal-950 text-charcoal-200">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-8 md:py-20">
        <div className="grid gap-12 md:grid-cols-[1.2fr_0.8fr_0.8fr_0.8fr]">
          <div>
            <Link to="/" className="inline-flex items-center gap-3" aria-label="Velko — accueil">
              <img src="/brand/velko-lockup-white.svg" alt="Velko" className="h-9 w-auto" />
            </Link>
            <p className="mt-6 max-w-xs font-marketing-body text-[15px] leading-relaxed text-charcoal-200">
              Le logiciel de caisse conçu pour le commerce africain. Vends, pilote et décide — même
              hors ligne.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://www.facebook.com/velkopos.sarl"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook Velko"
                className="flex h-10 w-10 items-center justify-center border-2 border-lime-500 text-lime-400 transition-colors hover:bg-lime-500 hover:text-charcoal-950"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.84c0-2.52 1.49-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.44 2.91h-2.33V22c4.78-.76 8.44-4.92 8.44-9.94z" />
                </svg>
              </a>
              <a
                href="https://wa.me/237656488879"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp Velko · +237 6 56 48 88 79"
                className="flex h-10 w-10 items-center justify-center border-2 border-lime-500 text-lime-400 transition-colors hover:bg-lime-500 hover:text-charcoal-950"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </a>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h3 className="font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-lime-400">
                {col.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {col.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="font-marketing-body text-[15px] text-charcoal-200 transition-colors hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t-2 border-charcoal-800 pt-6 font-marketing-mono text-[11px] uppercase tracking-[0.12em] text-charcoal-300 md:flex-row md:items-center">
          <div>
            © {year} Velko — une marque d’{' '}
            <Link
              to="/mentions-legales"
              className="underline decoration-charcoal-600 underline-offset-2 transition-colors hover:text-white"
            >
              OpenInTech SARL
            </Link>{' '}
            · Tous droits réservés
          </div>
          <div>Fait avec passion au Cameroun</div>
        </div>
      </div>
    </footer>
  );
}
